export const enable_widget_for_device = (device_id, enable) => ({
    type: 'APP_SETTINGS__WIDGETS_ENABLE_FOR_DEVICE',
    device_id,
    enable,
});
export const set_pin = (pin) => ({ type: 'UPDATE_APP_SETTINGS', setter: { pin } });
export const set_require_fingerprint = (require_fingerprint) => ({
    type: 'UPDATE_APP_SETTINGS',
    setter: { require_fingerprint },
});
export const open_ask_pin_dialog = () => ({
    type: 'APP_SETTINGS__OPEN_ASK_DIALOG',
});
export const close_ask_pin_dialog = () => ({
    type: 'APP_SETTINGS__CLOSE_ASK_DIALOG',
});
export const open_set_pin_dialog = () => ({
    type: 'APP_SETTINGS__OPEN_SET_DIALOG',
});
export const close_set_pin_dialog = () => ({
    type: 'APP_SETTINGS__CLOSE_SET_DIALOG',
});
export const open_pin_dont_match_dialog = () => ({
    type: 'APP_SETTINGS__OPEN_DONT_MATCH_DIALOG',
});
export const close_pin_dont_match_dialog = () => ({
    type: 'APP_SETTINGS__CLOSE_DONT_MATCH_DIALOG',
});
